import {
    AsAllowed,
    AsDisabled,
    LimitationProps
} from '~/components/Builder/Common/CreationLimitations/creationLimitations.types';
import i18next from 'i18next';
import invariant from 'ts-invariant';
import { QuestionType } from '~/types/builder.types';
import { countUploadQuestionBlocksInBlock } from '~/components/Builder/Block/QuestionBlock/question-block.utils';

export const MAX_UPLOAD_QUESTION_BLOCKS = 3;

export const forbidMoreThanMaxUploadQuestionBlocksForSingleBlock = ({
    sourceBlock,
    targetFlow
}: LimitationProps<'targetFlow' | 'sourceBlock'>) => {
    const isNotQuestionBlock = sourceBlock.type !== 'question_block';
    if (isNotQuestionBlock) {
        invariant(isNotQuestionBlock, 'sourceBlock is not a question_block');

        return;
    }

    if (sourceBlock.question?.question_type !== QuestionType.Upload) {
        return AsAllowed;
    }

    const t = i18next.getFixedT(null, 'builder', 'creation_limitation_dialog');

    if (targetFlow?.uploadQuestionBlocksCount >= MAX_UPLOAD_QUESTION_BLOCKS) {
        return AsDisabled(t('max_upload_question_blocks_reached'));
    }

    return AsAllowed;
};

export const forbidMoreThanMaxUploadQuestionBlocksForCompositionBlock = ({
    sourceBlock,
    targetFlow,
    notLoadedFlowChildren
}: LimitationProps<'targetFlow' | 'sourceBlock', 'notLoadedFlowChildren'>) => {
    const uploadQuestionBlocksCount = countUploadQuestionBlocksInBlock(
        sourceBlock,
        notLoadedFlowChildren
    );

    if (uploadQuestionBlocksCount === 0) {
        return AsAllowed;
    }

    const t = i18next.getFixedT(null, 'builder', 'creation_limitation_dialog');

    if (
        targetFlow?.uploadQuestionBlocksCount + uploadQuestionBlocksCount >
        MAX_UPLOAD_QUESTION_BLOCKS
    ) {
        return AsDisabled(t('max_upload_question_blocks_reached'));
    }

    return AsAllowed;
};
